export default __webpack_public_path__ + "static/media/icon-looking-glass.94e727e9.svg";